/**
 * Cricket em modo «sem palco» para plano Free: um quadro por utilizador no localStorage.
 * Não expira com o registo de projetos locais (24h); dados ficam até limpar o site ou trocar de conta.
 */

const STORAGE_PREFIX = 'gepetto_cricket_free_standalone_v1_';

/** Id sentinela passado como layoutId ao abrir o quadro de teste (sem API de layout). */
export const CRICKET_FREE_STANDALONE_LAYOUT_ID = '__gepetto_cricket_free__';

export function isCricketFreeStandaloneLayout(layoutId) {
  return String(layoutId || '') === CRICKET_FREE_STANDALONE_LAYOUT_ID;
}

function storageKey(userId) {
  return `${STORAGE_PREFIX}${userId || 'anon'}`;
}

function newId() {
  return typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `id_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

const DEFAULT_LIST_DEF = [
  { list_key: 'todo', title: 'A fazer', sort_order: 0 },
  { list_key: 'doing', title: 'Em andamento', sort_order: 1 },
  { list_key: 'done', title: 'Concluído', sort_order: 2 },
];

function createDefaultBoard() {
  const lists = DEFAULT_LIST_DEF.map((L) => ({
    id: newId(),
    board_id: null,
    list_key: L.list_key,
    title: L.title,
    sort_order: L.sort_order,
  }));
  return { lists, cards: [] };
}

/**
 * @param {string} userId
 * @returns {{ lists: object[], cards: object[] }}
 */
export function loadCricketFreeStandalone(userId) {
  if (!userId) return createDefaultBoard();
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return createDefaultBoard();
    const p = JSON.parse(raw);
    if (!p || !Array.isArray(p.lists) || !Array.isArray(p.cards)) return createDefaultBoard();
    if (p.lists.length === 0) return createDefaultBoard();
    return { lists: p.lists, cards: p.cards };
  } catch {
    return createDefaultBoard();
  }
}

/**
 * @param {string} userId
 * @param {{ lists: object[], cards: object[] }} data
 */
export function saveCricketFreeStandalone(userId, data) {
  if (!userId) return;
  try {
    localStorage.setItem(
      storageKey(userId),
      JSON.stringify({
        v: 1,
        lists: data.lists || [],
        cards: data.cards || [],
      }),
    );
  } catch {
    /* quota */
  }
}

export { newId as newStandaloneCricketId };
